import { Button, Typography } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { AuthPath } from 'pages/auth/route/authPath'

export const ExpiredFormBottom = () => {
  const onClick = () => {
    uiStore.changeRoute({
      path: `/${AuthPath.login}`,
    })
  }

  return (
    <div>
      <Typography
        variant={'body-sm-medium'}
        ariaLabel={'signInLink'}
        color={'var(--content-primary-tertiary)'}
      >
        Already have a Salesmsg account?
        <Button onClick={onClick} typeBtn={'link'} text={'Sign in'} />
      </Typography>
    </div>
  )
}
